// extracted by mini-css-extract-plugin
export default {"container":"styles_container__lsrID","text":"styles_text__F3wPU"};